import {action, makeObservable, observable} from "mobx";

export default class CategoryStore {
    state1: boolean
    state2: boolean
    index: number

    constructor() {
        makeObservable(this, {
            state1: observable,
            state2: observable,
            index: observable,

            setState1: action,
            setState2: action,
            setIndex: action
        });

        this.state1 = false
        this.state2 = false
        this.index = 0
    }

    setState1 = (value: boolean) => {
        this.state1 = value
    }

    setState2 = (value: boolean) => {
        this.state2 = value
    }

    setIndex = (value: number) => {
        this.index = value
    }

}